import styled from "@emotion/styled";
import * as Mui from "@mui/material";

const Ellipsis = styled(Mui.Box)({
  flex: 1,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  display: "ruby",
});

export default Ellipsis;